export const EXPRESSION_TYPE = {
    query: 1,
    where: 100,
    and: "and",
    or: "or",
    not: "not",
    eq: "eq",
    ne: "ne",
    lt: "lt",
    le: "le",
    gt: "gt",
    ge: "ge",
    any: "any",
    in: "in",
    contains: "contains",
    startsWith: "startsWith",
    endsWith: "endsWith"
};

export const ODATA_PARAMS = {
    $filter: "$filter",
    $select: "$select",
    $expand: "$expand",
    $orderby: "$orderby",
    $skip: "$skip",
    $top: "$top",
    $count: "$count",
    $search: "$search"
};

export const SF_PARAMS = {
    provider: "sf_provider",
    culture: "sf_culture",
    siteId: "sf_site",
    fallbackParams: "sf_fallback_prop_names",
    parentId: "parentId"
};

export const HEADER_NAMES = {
    contentType: "Content-Type",
    authorization: "Authorization",
    contentEncoding: "Content-Encoding",
    operation: "X-Operation",
    properties: "X-Sf-Properties",
    fileName: "X-File-Name",
    serviceRequest: "X-SF-Service-Request",
    choicesBinaryRepresentation: "X-SF-Binary-Choice-Representation",
    integrationMode: "X-SF-Integration-Mode",
    chunkOrdinal: "X-SF-Chunk-Ordinal",
    chunkSize: "X-SF-Chunk-Size",
    fileSize: "X-SF-File-Size",
    chunkedFileUploadSessionId: "X-SF-Chunked-File-Upload-Session-Id",
    blobStorageProviderName: "X-SF-Blob-Storage-Provider-Name"
};

export const HTTP_METHODS = {
    get: "GET",
    put: "PUT",
    post: "POST",
    patch: "PATCH",
    delete: "DELETE"
};

export const CONTENT_TYPES = {
    json: "application/json"
};
